// Profile pictures (FR-UI-09). The server lays each picture over the
// person's initials, and the stylesheet draws the initials again over a
// picture that fails, so none of this is needed to read a page. It only
// removes a picture that failed or was blocked, so nothing of it is left over
// the initials in a browser that draws a broken image some other way.

const PICTURE = ".avatar > img";

// A finished picture with no width failed, unless it is an SVG without a
// size of its own; decoding tells the two apart.
function dropIfBroken(img: HTMLImageElement): void {
  if (img.complete && img.naturalWidth === 0) {
    img.decode().catch(() => img.remove());
  }
}

// `error` doesn't bubble, so it is caught on the way down. That covers every
// picture, including those a swap or a live refresh brings later.
document.addEventListener(
  "error",
  (e) => {
    const img = e.target;
    if (img instanceof HTMLImageElement && img.matches(PICTURE)) img.remove();
  },
  true,
);

// The bundle is deferred, so some pictures failed before it ran.
function dropAllBroken(): void {
  for (const img of document.querySelectorAll<HTMLImageElement>(PICTURE)) {
    dropIfBroken(img);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", dropAllBroken);
} else {
  dropAllBroken();
}
